$(document).ready(function () {
  var language_th = $("#language_th");
  var language_en = $("#language_en");

  language_th.click(openTh);
  language_en.click(openEn);

  function openTh() {
    // language_list =  $(".disclosure-list__option");
    // for (i = 0; i < language_list.length; i++) {
    //   if(language_list[i]?.lang == 'th'){
    //     language_list[i].click();
    //   }
    // }
    window.location.href = "/pages/language";
  }

  function openEn() {
    // language_list =  $(".disclosure-list__option");
    // for (i = 0; i < language_list.length; i++) {
    //   if(language_list[i]?.lang == 'en'){
    //     language_list[i].click();
    //   }
    // }
    window.location.href = "/en/pages/language";
  }

});